// NOTE: must stay first so the global patches are installed before any module that relies on them
// at evaluation time (e.g. the typography dictionary) is pulled into the import graph.
import './modules/polyfills/install';

import { deviceInfo } from '@pelo-plugins/device';
import { getSettings } from './modules/settings/app.settings';
import { handleDeeplink } from './modules/app/utils/deeplink.utils';
import AppLauncher from './index';

const boot = async () => {
  await handleDeeplink();

  const model = await deviceInfo.getModel();
  window.RDK_MODEL_NAME = model;

  const { platformSettings } = getSettings();

  if (process.env.NODE_ENV === 'development' && platformSettings.inspector) {
    await import('@lightningjs/sdk/support/lib/lightning-inspect');
  }

  // mount the app renderer on the HTML page
  const app = AppLauncher();
  const canvas = app.stage.getCanvas();
  document.body.appendChild(canvas);
};

boot();
